module.exports = __webpack_public_path__ + "img/appstore.4838a2fb.png";